import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  moduleData: any;
  updateModuleData: any;
  addRowList1: any;
  addRowList2: any;
  handleDeleteRows: any;
  updateCheckBox: any;
}

const TController = ({
  moduleData,
  updateModuleData,
  addRowList1,
  addRowList2,
  handleDeleteRows,
  updateCheckBox,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead {...{ moduleData, updateModuleData, updateCheckBox }} />
        <TBody
          {...{
            moduleData,
            updateModuleData,
            addRowList1,
            addRowList2,
            handleDeleteRows,
          }}
        />
        <TFoot
          {...{
            moduleData,
            updateModuleData,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
